import { environment } from '@environments/environment'

export const generalConfigMap = {
  zoom: 15,
  minZoom: 2,
  maxZoom: 18,
  polylineColor: '#0000ff',
  polylineWeight: 3,
  defaultZIndex: 1,
  defaultMapBounds: [
    { lat: -80.31665537186683, lng: -80.66299438476564 },
    { lat: 84.85581777219805, lng: 225.1963806152344 },
  ],
  defaultMaxMapBounds: [
    { lat: 85, lng: -185 },
    { lat: -85, lng: 192 },
  ],

  polylineColorCurrentRoute: '#ff0037',
  zIndexCurrentRoute: 10,
  ZIndexCurrentMarker: 999,

  iconDefaultColor: '#000',
  iconStoppedColor: '#9e9e9e',
  iconIdleColor: '#03a9f4',
  iconDrivingColor: '#4caf50',
  iconOpacity: 0.8,
  iconStrokeWeight: 3,
  iconStrokeColor: '#ffffff',
  iconAnchorX: 12,
  iconAnchorY: 41,

  iconSequenceStrokeColor: '#000',
  iconSequenceFillColor: '#0000ff',
  iconSequenceCurrentRouteStrokeColor: '#ffffff',

  geofenceColor: '#ffff00',
  geofenceFillOpacity: 0.1,
  geofenceStrokeWeight: 2,
}

export const mapboxConfig = {
  mapboxMapStyleStreets: 'mapbox://styles/mapbox/streets-v12',
  mapboxMapStyleSatellite: 'mapbox://styles/mapbox/satellite-streets-v12',
  mapboxMapStyleLight: 'mapbox://styles/mapbox/light-v11',
  mapboxMapStyleDark: 'mapbox://styles/mapbox/dark-v11',
  mapboxMapStyleOutdoors: 'mapbox://styles/mapbox/outdoors-v12',
  mapboxMapStyleTraffic: 'mapbox://styles/mapbox/traffic-day-v2',

  mapboxMapStyleSatelliteRoyHill: 'mapbox://styles/linxio/cmcy3ovku00k201r50x050vpl',
  mapboxMapStyleStreetsRoyHill: 'mapbox://styles/linxio/cmcy3rpgq009e01sq3ufm3wkl',

  mapboxLibrariesUrls: [
    `https://api.mapbox.com/mapbox.js/v3.3.1/mapbox.js`,
    'https://api.mapbox.com/mapbox.js/v3.3.1/mapbox.css',
    `https://unpkg.com/leaflet.markercluster@1.4.1/dist/leaflet.markercluster.js`,
    'https://unpkg.com/leaflet.markercluster.freezable@1.0.0/dist/leaflet.markercluster.freezable.js',
    'https://unpkg.com/leaflet.markercluster@1.4.1/dist/MarkerCluster.css',
    'https://unpkg.com/leaflet.markercluster@1.4.1/dist/MarkerCluster.Default.css',
    'https://cdn.jsdelivr.net/npm/leaflet-polylinedecorator@1.6.0/dist/leaflet.polylineDecorator.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet.draw/1.0.4/leaflet.draw.js',
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet.draw/1.0.4/leaflet.draw.css',
    'https://api.mapbox.com/mapbox.js/plugins/leaflet-fullscreen/v1.0.1/Leaflet.fullscreen.min.js',
    'https://api.mapbox.com/mapbox.js/plugins/leaflet-fullscreen/v1.0.1/leaflet.fullscreen.css',
  ],

  iconDefaultUrl: 'https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi-dotless2.png',
  iconDefaultSize: [42, 42],
  iconCurrentSize: [48, 48],
  iconDefaultAngle: 0,
  iconRotationOrigin: 'center center',

  iconSequencePixelSize: 8,
  iconSequencePolygon: false,
  iconSequenceStroke: true,
  iconSequenceOffset: 0,
  iconSequenceRepeat: 200,

  tooltipAnchorX: -10,
  tooltipAnchorY: -10,
  tooltipDirection: 'top',
  tooltipClassVehicleMarker: 'vehicle-marker-tooltip',
  tooltipClassStopMarker: 'stop-marker-tooltip',
  tooltipClassStopMarkerHover: 'stop-marker-tooltip-hover',
  tooltipClassCurrentMarker: 'current-marker',

  drawControlPosition: 'topleft',
  drawControlAllowIntersection: false,
  drawControlShowArea: true,
  drawControlPolyline: false,
  drawControlOff: false,
  drawControlEdit: false,
  drawControlRemove: false,

  controlsPosition: 'topleft',

  geocoderControlPosition: 'topright',
  geocoderAutocomplete: true,

  mapAttributionControl: false,
  mapWorldCopyJump: true,
  mapMaxBoundsViscosity: 1.0,

  popupMaxWidth: 200,
  popupMinWidth: 185,
  popupMaxHeight: 200,
  popupCloseButton: false,
}

export const googleMapConfig = {
  googleMapLibrariesUrls: [`https://maps.google.com/maps/api/js?libraries=geometry,drawing&key=${environment.apiKey}`],

  markerClusterImagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',

  iconScale: 0.8,
  iconHoverScale: 1,

  iconSequenceRepeat: '20%',
  iconSequencePath: 'FORWARD_CLOSED_ARROW',
  iconSequenceOffset: '50%',

  stopMarkerLabelColor: '#ffffff',
  stopMarkerDraggable: false,

  geofenceClickable: true,
  geofenceEditable: true,
}
